const locale = {
  placeholder: 'Pilih waktu',
  rangePlaceholder: ['Waktu awal', 'Waktu akhir']
};
export default locale;